import React from "react";
import "./Faq_Accordion.css";
import { Accordion } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

function Faq_Accordion() {
  return (
    <>
      <section className="Faq_Accordion">
        <Accordion defaultActiveKey="1">
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <div className='question_div'>
                <p className='question'>1. What is a personal loan? </p>
              </div>

              <div className='icon_holder minus_icon'>
                <FontAwesomeIcon icon={faMinus} className='icon' />
              </div>
              <div className='icon_holder plus_icon'>
                <FontAwesomeIcon icon={faPlus} className='icon' />
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <p>
                A personal loan is an unsecured loan that individuals can borrow from a bank, NBFC, or finance company to meet
                personal financial needs such as medical expenses, travel, education, home renovation, or debt consolidation.</p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <div className='question_div'>
                <p className='question'>2.what is the interest rate on personal loan?</p>
              </div>

              <div className='icon_holder minus_icon'>
                <FontAwesomeIcon icon={faMinus} className='icon' />
              </div>
              <div className='icon_holder plus_icon'>
                <FontAwesomeIcon icon={faPlus} className='icon' />
              </div>

            </Accordion.Header>
            <Accordion.Body>
              <p>
                The interest rate on a personal loan varies depending on the lender, the applicant’s credit score, income, repayment
                capacity, and loan amount. Generally, in India, personal loan interest rates range between 10% to 24% per annum.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <div className='question_div'>
                <p className='question'>3.What document are required for personal loan?</p>
              </div>

              <div className='icon_holder minus_icon'>
                <FontAwesomeIcon icon={faMinus} className='icon' />
              </div>
              <div className='icon_holder plus_icon'>
                <FontAwesomeIcon icon={faPlus} className='icon' />
              </div>

            </Accordion.Header>
            <Accordion.Body>
              <p>
                The commonly required documents for a personal loan are:
                Identity Proof: Aadhaar Card, PAN Card, Passport, or Voter ID
                Address Proof: Utility Bill, Aadhaar Card, Passport, or Ration Card
                Income Proof: Salary slips (last 3–6 months), bank statements, or income tax returns
                Employment Proof: Company ID card or employment certificate
                Photographs: Passport-size photos
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </section>
    </>
  );
}

export default Faq_Accordion;
